import React, { useState, useEffect } from "react";
import {
  Button,
  TextField,
  Paper,
  Typography,
  Box,
  FormControlLabel,
  Radio,
  RadioGroup,
  Grid,
  CircularProgress,
  Divider,
  Chip,
} from "@mui/material";
import { Send as SendIcon } from "@mui/icons-material";

export default function CC503({ submitForm, declarationInfo }) {
  const [loading, setLoading] = useState(true);
  const [discrepanciesAccepted, setDiscrepanciesAccepted] = useState("yes");
  const [justification, setJustification] = useState("");

  const [messageSender, setMessageSender] = useState("");
  const [messageRecipient, setMessageRecipient] = useState("");

  useEffect(() => {
    if (declarationInfo) {
      if (declarationInfo.declaration_info) {
        setMessageSender(declarationInfo.declaration_info.message_sender || "");
        setMessageRecipient(
          declarationInfo.declaration_info.message_recipient || ""
        );
      }
    }

    setLoading(false);
  }, [declarationInfo]);

  const handleSubmit = () => {
    const requestData = {
      discrepancies_accepted: discrepanciesAccepted,
      justification: justification,
    };

    submitForm({ messageType: "CC503", data: requestData });
  };

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="200px"
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <div style={{ margin: "20px 0" }}>
      <Paper
        sx={{ boxShadow: "none" }}
        style={{
          padding: "20px",
          marginBottom: "20px",
          backgroundColor: "#f5f5f5",
        }}
      >
        <Typography variant="h6" gutterBottom>
          Declaration Information
        </Typography>
        <Divider style={{ marginBottom: "15px" }} />
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Message Sender"
              value={messageSender}
              onChange={(e) => setMessageSender(e.target.value)}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Message Recipient"
              value={messageRecipient}
              onChange={(e) => setMessageRecipient(e.target.value)}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="body2" color="textSecondary" gutterBottom>
              MRN
            </Typography>
            <Box display="flex" alignItems="center" gap={1}>
              <Typography variant="body1" style={{ fontWeight: 500 }}>
                {declarationInfo?.mrn || "N/A"}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="body2" color="textSecondary" gutterBottom>
              Message Type
            </Typography>
            <Chip label="CC503" color="primary" />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body2" color="textSecondary" gutterBottom>
              Preparation Date & Time
            </Typography>
            <Typography variant="caption" color="textSecondary">
              Will be automatically set to current moment when submitting
            </Typography>
          </Grid>
        </Grid>
      </Paper>

      <Paper
        sx={{ boxShadow: "none" }}
        style={{ padding: "20px", marginBottom: "20px" }}
      >
        <Typography variant="h6" gutterBottom>
          CC503 - Mesaj de acceptare discrepante minore
        </Typography>
        <Divider style={{ marginBottom: "15px" }} />

        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="subtitle1" gutterBottom>
              Discrepancies Accepted
            </Typography>
            <RadioGroup
              value={discrepanciesAccepted}
              onChange={(e) => setDiscrepanciesAccepted(e.target.value)}
            >
              <FormControlLabel value="yes" control={<Radio />} label="Yes" />
              <FormControlLabel value="no" control={<Radio />} label="No" />
            </RadioGroup>
          </Grid>

          <Grid item xs={12}>
            <TextField
              label="Justification"
              value={justification}
              onChange={(e) => setJustification(e.target.value)}
              fullWidth
              multiline
              rows={4}
              placeholder="Enter justification for the response..."
            />
          </Grid>
        </Grid>
      </Paper>

      <Box display="flex" gap={2} justifyContent="center" mt={3}>
        <Button
          variant="contained"
          color="primary"
          startIcon={<SendIcon />}
          onClick={handleSubmit}
        >
          Trimite CC503
        </Button>
      </Box>
    </div>
  );
}
